// extracted by mini-css-extract-plugin
export default {"button-inner":"MZ00p5d___button-inner","buttonInner":"MZ00p5d___button-inner"};